export default __webpack_public_path__ + "static/media/pops.4e5a1e30.png";